import {SignotecNativeCaptureService} from '@/utils/signotec-native-capture.service';

class SignotecService {

  private nativeServiceSingleton: SignotecNativeCaptureService;

  constructor() {
    this.nativeServiceSingleton = new SignotecNativeCaptureService();
  }

  getNativeServiceSingleton(): SignotecNativeCaptureService {
    return this.nativeServiceSingleton;
  }

}

const SIGNOTEC_SERVICE_INSTANCE = new SignotecService();

export {SIGNOTEC_SERVICE_INSTANCE};
